import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {SamoobslugaService} from '../../services/samoobsluga/samoobsluga.service';
import {Observable, of, zip} from 'rxjs';
import {Action} from '@ngrx/store';
import {map, mergeMap} from 'rxjs/operators';
import {pobierzDaneZgloszenia} from './samoobsluga.actions';

@Injectable()
export class SamoobslugaEffects{

  constructor(private actions$: Actions, private samoobslugaService: SamoobslugaService) {
  }

  pobierzDaneZgloszenia$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(pobierzDaneZgloszenia),
    mergeMap((action) => {
      return zip(of(action), this.samoobslugaService.pobierzDaneZgloszenia(action.daneZgloszeniaZapytanie));
    }),
    map(([action, samoobsluga]) => {
      return action.nastepnaAkcja(samoobsluga);
    })
  ))

}
